import { AlertCircle } from 'lucide-react';
import { SlideIn } from '@/components/motion';

interface IncompleteProfileBannerProps {
  percentage: number;
}

export function IncompleteProfileBanner({ percentage }: IncompleteProfileBannerProps) {
  if (percentage >= 100) {
    return null;
  }

  return (
    <SlideIn direction="up">
      <div
        className="rounded-2xl sm:rounded-3xl lg:rounded-[40px] border-[3px] border-amber-500/60 p-5 sm:p-6 lg:p-8 text-center"
        style={{ background: 'linear-gradient(99.87deg, rgba(245, 158, 11, 0.1) 0%, rgba(249, 115, 22, 0.1) 100%)' }}
      >
        <div className="w-16 h-16 sm:w-20 sm:h-20 bg-white rounded-full mx-auto flex items-center justify-center mb-4">
          <AlertCircle className="h-6 w-6 sm:h-8 sm:w-8 text-amber-500" />
        </div>
        <h2 className="text-xl sm:text-2xl lg:text-[32px] text-slate-900 tracking-tight mb-2">
          Complete your profile to start getting matched
        </h2>
        <p className="text-base sm:text-lg text-slate-500 max-w-[600px] mx-auto">
          Your profile is {percentage}% complete. Add your experience and portfolio to increase your match rate by 3x and start receiving client opportunities.
        </p>
      </div>
    </SlideIn>
  );
}
